import { keyframes } from '@emotion/react'
import React, { createContext, useContext, useLayoutEffect, useState } from 'react'
import { ThemeType } from '../../themes/legacyThemes'
import { SwashbuckleProvider } from '../SwashbuckleProvider/SwashbuckleProvider'

import { HB_DEFAULT, HB_DEFAULT_NEUTRAL } from '../../themes/legacyThemes'
import { darkTheme, lightTheme } from '../../themes/themes'

interface LegacyThemeProviderProps {
  theme?: ThemeType,
  children: JSX.Element
}

const emptyTheme: ThemeType = {
  name: undefined, 
  tokens: {}, 
  isLightThemeType: false,
  isLightNeutral: false
}

const LegacyThemeContext = createContext<{
  theme: ThemeType,
  setTheme: React.Dispatch<React.SetStateAction<ThemeType>>
}>({
  theme: emptyTheme,
  setTheme: () => null
})

const oldToNewThemeMapping = (oldThemeName) => {
  if (typeof oldThemeName === 'undefined') {
    return {} 
  }

  if (oldThemeName === HB_DEFAULT || oldThemeName === HB_DEFAULT_NEUTRAL) { 
    return darkTheme
  }

  return lightTheme
}

// References to theme in this function refer to exports from 
// src/lib/themes/legacyThemes.ts
export const LegacyThemeProvider = ({ children, theme: initialTheme = emptyTheme }: LegacyThemeProviderProps) => {
  const [theme, setTheme] = useState(initialTheme)

  useLayoutEffect(() => {
    const { tokens } = theme

    Object.keys(tokens).forEach((token) => {
      document.documentElement.style.setProperty(`--${token}`, tokens[token])
    })

    return () => {
      Object.keys(tokens).forEach((token) => {
        document.documentElement.style.removeProperty(`--${token}`)
      })
    }
  }, [theme.name])

  useLayoutEffect(() => {
    setTheme(initialTheme || emptyTheme)
  }, [initialTheme.name])
 
  return (
      <LegacyThemeContext.Provider value={{
        setTheme,
        theme
      }}>
        <SwashbuckleProvider theme={oldToNewThemeMapping(theme.name)}>
        {children}
        </SwashbuckleProvider>
      </LegacyThemeContext.Provider>
  )
}

export const useTheme = () => {
  return useContext(LegacyThemeContext)
}